import React from 'react';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
type SectionProps = {
  children: React.ReactNode;
  className?: string;
  id?: string;
};
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  return <motion.section id={id} initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.5
  }} className={`relative mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 md:py-20 lg:px-8 ${className}`} data-id="element-290" data-mp="136uhh320le01">
      {children}
    </motion.section>;
}
type CTAProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
};
export function CTAButton({
  children,
  href = '#pricing',
  className = '',
  fullWidth = false
}: CTAProps) {
  return <motion.a href={href} whileHover={{
    scale: 1.015
  }} whileTap={{
    scale: 0.985
  }} className={cn(`cta-shimmer relative mx-auto inline-flex max-w-full items-center justify-center overflow-hidden rounded-full bg-brand-green px-6 py-4 text-center text-sm font-bold leading-tight text-brand-cream shadow-[0_10px_24px_rgba(23,59,43,.22)] transition-colors hover:bg-brand-dark focus:outline-none focus:ring-2 focus:ring-brand-yellow focus:ring-offset-2 focus:ring-offset-brand-surface sm:px-9 md:text-base ${fullWidth ? 'w-full' : 'w-fit'} ${className}`)} data-id="element-291" data-mp="20srwurl3l37r">
      {children}
    </motion.a>;
}